import { createContext } from 'react';

export type CookiesContextValue = string | Record<string, unknown> | undefined;

export const CookiesContext = createContext<CookiesContextValue>(undefined);
